import React from 'react';
import { useDialogs } from 'src/hooks/useDialogs';
import { Modal } from 'src/design/molecules/Modal';
import { AddClassificationForm } from './AddClassificationForm';

/** @registry Modal for creating/editing/deleting a classification and its levels. */
export const AddClassificationDialog = React.memo(
  function AddClassificationDialog() {
    const {
      addClassificationOpen,
      setAddClassificationOpen,
      selectedClassification,
    } = useDialogs();

    return (
      <Modal
        opened={addClassificationOpen}
        onClose={() => setAddClassificationOpen(false)}
        size="lg"
        title={
          selectedClassification
            ? `Edit Classification: ${selectedClassification.name}`
            : 'Add Classification'
        }
      >
        <AddClassificationForm
          selectedClassification={selectedClassification}
          setAddClassificationOpen={setAddClassificationOpen}
        />
      </Modal>
    );
  },
);
